import { render, staticRenderFns } from "./TaskCreateEmployee.vue?vue&type=template&id=13a51854"
import script from "./TaskCreateEmployee.vue?vue&type=script&lang=js"
export * from "./TaskCreateEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports